import React from 'react'
import { Select } from 'antd'
// const parseValues = values => {
//   // Stringify object values, Select doesn't accept type "object" for prop value
//   return (
//     values &&
//     values.map(e => {
//       delete e.agreementStoreId
//       return JSON.stringify(e)
//     })
//   )
// }
const StoreSelect = props => {
  return (
    <Select
      style={{ width: '100%' }}
      mode="multiple"
      placeholder="Seleziona uno o più negozi"
      onChange={props.onChange}
      disabled={props.disabled}
      value={props.value}
      defaultValue={[]}>
      {props.stores.filter(store => !props.value || (props.value && props.value.includes(0) && store.storeCode === 0) || (props.value && !props.value.includes(0))).map((store, index) => (
          <Select.Option key={index} value={store.storeCode}>
            {store.storeCode !== 0 && `${store.storeCode} - `}
            {store.storeDesc}
          </Select.Option>
        ))}
    </Select>
  )
};
export default StoreSelect



// WEBPACK FOOTER //
// ./src/components/StoreSelect/index.js